import { 
	LOGIN_SUCCESS, 
	SIGNOUT_SUCCESS, 
	SIGNUP_SUCCESS, 
	SET_IS_VERIFIED,
	SET_IS_APPROVED,
	SET_USER_DEVICE_ID
} from '../types';

const initialStore = {
	isVerified: false,
	approved: false,
	authError: null,
	signUpSuccess: false,
	userDeviceId: null
};

const authReducer = (state = initialStore, action) => {
	switch(action.type) {
		case LOGIN_SUCCESS: {
			return {...state, authError: null}
		}
		case SIGNOUT_SUCCESS: {
			return {...state, isVerified: false,approved: false }
		}
		case SIGNUP_SUCCESS: {
			return {...state, signUpSuccess: action.payload};
		}
		case SET_IS_VERIFIED: {
			return {...state, isVerified: action.payload};
		}
		case SET_IS_APPROVED: {
			return {...state, approved: action.payload};
		}
		case SET_USER_DEVICE_ID: {
			return {...state, userDeviceId: action.payload};
		}
		default : return state;
	};
};

export default authReducer;
